import React from "react";
import PostAttachments from "./PostAttachments";
import Linkify from "linkifyjs/react";
import LinkPreview from "./LinkPreview";

export default ({ post, postSetter }) => {
  const [showResults, setShowResults] = React.useState(false);

  function clickHandler() {
    setShowResults(true);
  }

  function openURL(value) {
    window.open(value, "_blank");
  }

  function formatter(value, type) {
    // https://player.vimeo.com/video/403530213
    if (value.includes("vimeo.com")) {
      newURL = value;
      if (value.includes("https://vimeo.com")) {
        newURL = [value.slice(0, 8), "player.", value.slice(8)].join("");
        // newURL = newURL.substring(0, newURL.indexOf('?'));
        newURL = [newURL.slice(0, 25), "video/", newURL.slice(25)].join("");
      }
      return (
        <>
          <a onClick={() => openURL(value)} className="embed-link-anchor">
            {value}
          </a>
          <div className="embed-link-iframe-vimeo-div">
            <iframe
              src={`${newURL}`}
              className="embed-link-iframe"
              frameBorder="0"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowtransparency="true"
            ></iframe>
          </div>
        </>
      );
    } else {
      if (value.includes("youtube.com") || value.includes("youtu.be")) {
        var newURL;
        if (value.includes("youtu.be")) {
          newURL = [value.slice(0, 17), "embed/", value.slice(17)].join("");
          newURL = newURL.replace("watch?v=", "").replace("youtu.be", "youtube.com");
        } else {
          if (value.includes("http://")) {
            var newURL = [value.slice(0, 23), "embed/", value.slice(23)].join("");
            newURL = newURL.replace("watch?v=", "").replace("http://", "https://");
          } else {
            newURL = [value.slice(0, 24), "embed/", value.slice(24)].join("");
            newURL = newURL.replace("watch?v=", "");
          }
        }

        if (newURL.includes("&")) {
          newURL = newURL.substring(0, newURL.indexOf("&"));
        }
        return (
          <>
            <a onClick={() => openURL(value)} className="embed-link-anchor">
              {value}
            </a>
            <br />
            <div className="embed-link-iframe-div">
              <iframe
                src={`${newURL}`}
                frameBorder="0"
                className="embed-link-iframe"
                allow="autoplay; encrypted-media"
                allowFullScreen="true"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                title="video"
              />
            </div>
          </>
        );
      } else {
        return (
          <>
            <a onClick={() => openURL(value)}>{value}</a>
            {value && value != "undefined" && <LinkPreview useDefault={false} url={value} />}
          </>
        );
      }
    }
  }

  function formatter_embabed_url(value, type) {
    /// https://player.vimeo.com/video/403530213
    if (value.includes("vimeo.com")) {
      newURL = value;
      if (value.includes("https://vimeo.com")) {
        newURL = [value.slice(0, 8), "player.", value.slice(8)].join("");
        // newURL = newURL.substring(0, newURL.indexOf('?'));
        newURL = [newURL.slice(0, 25), "video/", newURL.slice(25)].join("");
      }
      return (
        <>
          <div className="embed-link-iframe-vimeo-div">
            <iframe
              src={`${newURL}`}
              className="embed-link-iframe"
              frameBorder="0"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowtransparency="true"
            ></iframe>
          </div>
        </>
      );
    } else {
      if (value.includes("youtube.com") || value.includes("youtu.be")) {
        var newURL;
        if (value.includes("youtu.be")) {
          newURL = [value.slice(0, 17), "embed/", value.slice(17)].join("");
          newURL = newURL.replace("watch?v=", "").replace("youtu.be", "youtube.com");
        } else {
          if (value.includes("http://")) {
            var newURL = [value.slice(0, 23), "embed/", value.slice(23)].join("");
            newURL = newURL.replace("watch?v=", "").replace("http://", "https://");
          } else {
            newURL = [value.slice(0, 24), "embed/", value.slice(24)].join("");
            newURL = newURL.replace("watch?v=", "");
          }
        }

        if (newURL.includes("&")) {
          newURL = newURL.substring(0, newURL.indexOf("&"));
        }
        return (
          <>
            <div className="embed-link-iframe-div">
              <iframe
                src={`${newURL}`}
                frameBorder="0"
                className="embed-link-iframe"
                allow="autoplay; encrypted-media"
                allowFullScreen="true"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                title="video"
              />
            </div>
          </>
        );
      } else {
        return <>{value && value != "undefined" && <LinkPreview useDefault={false} url={value} />}</>;
      }
    }
  }

  return (
    <div className="post-body ml-6">
      <Linkify tagName="pre" options={{ tagName: "div", className: "embed-link", format: formatter }}>
        {post.text}
      </Linkify>
      <Linkify tagName="pre" options={{ tagName: "div", className: "embed-link", format: formatter_embabed_url }}>
        {post.embaded_url}
      </Linkify>
      {/* {post.link_preview && post.link_preview != "undefined" && <LinkPreview useDefault={false} link_preview={post.link_preview} />} */}
      <PostAttachments
        attachmentsSetter={(newAttachments) => postSetter({ ...post, attachments: newAttachments })}
        post={post}
        attachments={post.attachments}
      />
    </div>
  );
};
